import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterAuthByPasswordForm.styl';


Vue.component('BXmakerAuthuserphoneEnterAuthByPasswordForm', {
    name: 'BXmakerAuthuserphoneEnterAuthByPasswordForm',
    data() {
        return {};
    },
    computed: {
        inputText() {
            let ar = [];
            let name = '';

            ar.push(this.$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_BY_PASSWORD_FORM_PHONE);

            if(this.$root.isEnabledAuthByLogin)
            {
                ar.push(this.$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_BY_PASSWORD_FORM_LOGIN);
            }

            if(this.$root.isEnabledAuthByEmail)
            {
                ar.push(this.$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_BY_PASSWORD_FORM_EMAIL);
            }

            if(ar.length > 1)
            {
                name = ar.slice(0, -1).join(', ');
                name += ' ' + this.$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_BY_PASSWORD_FORM_OR + ' ';
                name += ar.slice(-1);
            }
            else
            {
                name = ar.join(', ');
            }

            name = name.substring(0,1).toUpperCase() + name.substring(1);

            return name;
        },
    },
    methods: {
        onChangePhone(data){
            this.$root.setPLE(data.formattedValue);
        },
        onEnterPLE(){
            this.$refs.password.focus();
        },
        onEnterPassword(){
            this.onClickConfirm();
        },
        onCompleteCaptcha(){
            this.onClickConfirm();
        },
        onClickConfirm(){
            if(this.$root.isFullCaptcha)
            {
                this.$root.authByPassword();
            }
        },
        onClickBack(){
            this.$root.setIsAuthByPassword(false);
        }
    },
    template: `
            <div class="bxmaker-authuserphone-enter-auth-by-password-form"  >
                 
                 <slot name="message" />  
                        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />
                 </slot>     
                   
                                      
                 <slot name="phone">                        
           
                        <BXmakerAuthuserphoneInputPhone  v-if="!$root.isEnabledAuthByLogin && !$root.isEnabledAuthByEmail && $root.isEnabledPhoneMask"
                            :title="inputText" 
                            :value="$root.ple" 
                            @onChange="onChangePhone" 
                            @onEnter="onEnterPLE" 
                            name="PHONE_LOGIN_EMAIL" 
                            :defaultCountry="$root.phoneMaskDefaultCountry"
                            :countryTopList="$root.phoneMaskCountryTopList"                          
                        />
                             
                        <BXmakerAuthuserphoneInput v-else
                            :title="inputText" 
                            :value="$root.ple" 
                            @onInput="$root.setPLE" 
                            @onEnter="onEnterPLE" 
                            name="PHONE_LOGIN_EMAIL"
                        />
                 </slot>
                    
                 <slot name="pass">                   
                        <BXmakerAuthuserphoneInputPassword 
                            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_BY_PASSWORD_FORM_PASSWORD" 
                            :value="$root.password" 
                            @onInput="$root.setPassword" 
                            @onEnter="onEnterPassword" 
                            name="PASSWORD" 
                            ref="password"                         
                        />
                 </slot>
                 
                    
                 <BXmakerAuthuserphoneLink @onClick="$root.toForget" class="bxmaker-authuserphone-enter-auth-by-password-form__forget">
                    {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_BY_PASSWORD_FORGET}}   
                 </BXmakerAuthuserphoneLink> 
                                        
                    
                 <slot name="captcha">
                      <BXmakerAuthuserphoneCaptcha 
                          :code="$root.captchaCode"
                          :src="$root.captchaSrc"
                          :length="$root.captchaLength"
                          :loader="$root.captchaLoader"
                          @onInput="$root.setCaptchaCode"
                          @onComplete="onCompleteCaptcha"
                          @onRefresh="$root.refreshCaptcha"
                         />  
                 </slot>   
                     
                    
                 <slot name="request">
                    <BXmakerAuthuserphoneButton 
                        :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_BY_PASSWORD_FORM_BUTTON"  
                        :loader="$root.startLoader"
                        @onClick="onClickConfirm" 
                    />
                 </slot>
                    
                 <div class="bxmaker-authuserphone-enter-auth-by-password-form__back">
                   <BXmakerAuthuserphoneLink @onClick="onClickBack" >
                      {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_BY_PASSWORD_BACK}}   
                   </BXmakerAuthuserphoneLink> 
                 </div>
                           
                
                   
                             
            </div>
        `,
});